<template>
    <div class="flex flex-col min-h-screen bg-gray-50">
        <div class="grow py-12 flex flex-col items-center justify-center text-gray-900 ">
            <div class="inline-block text-[1.75rem] font-bold text-center after:content-[''] after:block after:h-[0.3125rem] after:bg-primary">
                系統公告
            </div>
            <div class="px-4 w-full xs:w-4/5 md:max-w-[30rem] text-lg xs:text-lg xs:text-[1.3125rem] my-12 lg:my-16 text-center">
                <router-view />
                <div
                    v-if="isDevMode() "
                    class="mt-4 text-center"
                >
                    <button
                        class="btn gradient-primary rounded-full"
                        @click="goNext"
                    >
                        返回
                    </button>
                </div>
            </div>
        </div>
        <div class="w-full">
            <div class="w-4/5 min-w-[12.5rem] max-w-[28.75rem] mx-auto mb-0">
                <img
                    src="@/assets/images/page/announcement-img.svg"
                    alt="系統公告"
                    class="w-full"
                >
            </div>
            <div class="gradient-primary text-center text-base p-3">
                富邦人壽 線上交易專區
            </div>
        </div>
    </div>
</template>
<script>
import { useRouter } from 'vue-router';
import routeName from '@/router/constant.js';
import { isDevMode } from '@/utils/is';
export default {
    setup() {
        const router = useRouter();
        const goNext = () => {
            router.push({ name: routeName.HOME });
        };
        return {
            goNext, isDevMode, routeName
        };
    },
};
</script>
<style scoped>
.grow {
    flex-grow: 1;
}
</style>
